import moment from 'moment';
import isInclusivelyAfterDay from "react-dates/esm/utils/isInclusivelyAfterDay";
export var isDayBlockedOrBeforeCurrentDate = function isDayBlockedOrBeforeCurrentDate(day, getIsDayBlocked) {
  return !!day && (getIsDayBlocked(day) || !isInclusivelyAfterDay(day, moment()));
};